import script from "./ChanelC2BTranslate.vue?vue&type=script&setup=true&lang=js"
export * from "./ChanelC2BTranslate.vue?vue&type=script&setup=true&lang=js"

import "./ChanelC2BTranslate.vue?vue&type=style&index=0&id=f60ae8b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f60ae8b8"]])

export default __exports__